import { render, staticRenderFns } from "./goods-price-tpl-select-dialog.vue?vue&type=template&id=c2694f2c&scoped=true"
import script from "./goods-price-tpl-select-dialog.vue?vue&type=script&lang=js"
export * from "./goods-price-tpl-select-dialog.vue?vue&type=script&lang=js"
import style0 from "./goods-price-tpl-select-dialog.vue?vue&type=style&index=0&id=c2694f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2694f2c",
  null
  
)

export default component.exports